// oxlint-disable unicorn/no-empty-file
// Web uses TanStack Query's default `onlineManager` (`window` online/offline events)
